/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import {
    type SendRequest,
    SendRequestFromJSON,
    SendRequestToJSON
} from '../models/SendRequest'
import {
    type V1ErrorResponse,
    V1ErrorResponseFromJSON,
    V1ErrorResponseToJSON
} from '../models/V1ErrorResponse'
import {
    type V1MotiActions,
    V1MotiActionsFromJSON,
    V1MotiActionsToJSON
} from '../models/V1MotiActions'
import {
    type V1MotiPayload,
    V1MotiPayloadFromJSON,
    V1MotiPayloadToJSON
} from '../models/V1MotiPayload'

export interface ListenRequest {
    /**
     *
     */
    action: V1MotiActions
}

export interface SendOperationRequest {
    /**
     *
     */
    action: V1MotiActions
    /**
     *
     */
    sendRequest: SendRequest
}

/**
 *
 */
export class MotiApi extends runtime.BaseAPI {
    /**
     * Creates request options for listen without sending the request
     */
    async listenRequestOpts(
        requestParameters: ListenRequest
    ): Promise<runtime.RequestOpts> {
        if (requestParameters['action'] == null) {
            throw new runtime.RequiredError(
                'action',
                'Required parameter "action" was null or undefined when calling listen().'
            )
        }

        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/motivation/listen/{action}`
        urlPath = urlPath.replace(
            '{action}',
            encodeURIComponent(String(requestParameters['action']))
        )

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     * Get the authenticated user profile
     */
    async listenRaw(
        requestParameters: ListenRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1MotiPayload>> {
        const requestOptions = await this.listenRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1MotiPayloadFromJSON(jsonValue)
        )
    }

    /**
     * Get the authenticated user profile
     */
    async listen(
        requestParameters: ListenRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1MotiPayload> {
        const response = await this.listenRaw(requestParameters, initOverrides)
        return await response.value()
    }

    /**
     * Creates request options for send without sending the request
     */
    async sendRequestOpts(
        requestParameters: SendOperationRequest
    ): Promise<runtime.RequestOpts> {
        if (requestParameters['action'] == null) {
            throw new runtime.RequiredError(
                'action',
                'Required parameter "action" was null or undefined when calling send().'
            )
        }

        if (requestParameters['sendRequest'] == null) {
            throw new runtime.RequiredError(
                'sendRequest',
                'Required parameter "sendRequest" was null or undefined when calling send().'
            )
        }

        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        headerParameters['Content-Type'] = 'application/json'

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/motivation/send/{action}`
        urlPath = urlPath.replace(
            '{action}',
            encodeURIComponent(String(requestParameters['action']))
        )

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendRequestToJSON(requestParameters['sendRequest'])
        }
    }

    /**
     * send moti
     */
    async sendRaw(
        requestParameters: SendOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.sendRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.VoidApiResponse(response)
    }

    /**
     * send moti
     */
    async send(
        requestParameters: SendOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<void> {
        await this.sendRaw(requestParameters, initOverrides)
    }
}
